export default "__VITE_ASSET__B6WpleFB__"